export enum DiscountType {
  Percentage = 'percentage',
  Flat = 'flat',
}

export enum AppliesTo {
  ProcessingFee = 'processing_fee',
  Emi = 'emi',
  Foreclosure = 'foreclosure',
}

export enum CouponStatus {
  Active = 'active',
  Scheduled = 'scheduled',
  Paused = 'paused',
  Expired = 'expired',
  Exhausted = 'exhausted',
}

export type CouponSortField =
  | 'code'
  | 'discountType'
  | 'discountValue'
  | 'appliesTo'
  | 'currentUses'
  | 'maxTotalUses'
  | 'validFrom'
  | 'validUntil'
  | 'isActive';

export interface Coupon {
  id: string;
  code: string;
  description?: string;
  discountType: DiscountType;
  discountValue: number;
  maxDiscount?: number | null;
  appliesTo: AppliesTo;
  minLoanAmount?: number;
  productIds?: string[] | null;
  channel?: string | null;
  maxTotalUses: number;
  currentUses?: number;
  maxPerUser?: number;
  validFrom: string;
  validUntil: string;
  isActive?: boolean;
  createdBy?: string;
  userId?: string | null;
}

export interface CouponWithStatus extends Coupon {
  status: CouponStatus;
}

export interface CouponUsageSummary {
  currentUses: number;
  maxTotalUses: number;
  uniqueUsers: number;
}

export interface CouponDetail extends CouponWithStatus {
  usage: CouponUsageSummary;
}

export interface CouponRedemption {
  id: string;
  couponId: string;
  userId: string;
  applicationId?: string;
  originalAmount?: number;
  discountAmount?: number;
  finalAmount?: number;
  redeemedAt?: string | null;
  status: 'pending' | 'redeemed';
}

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ListCouponsAdminParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: CouponStatus;
  discountType?: DiscountType;
  appliesTo?: AppliesTo;
  sortBy?: CouponSortField;
  sortDir?: 'ASC' | 'DESC';
}

export interface ListRedemptionsParams {
  page?: number;
  pageSize?: number;
}

export interface CreateCouponPayload {
  code: string;
  description?: string;
  discountType: DiscountType;
  discountValue: number;
  maxDiscount?: number | null;
  appliesTo: AppliesTo;
  minLoanAmount?: number;
  productIds?: string[] | null;
  channel?: string | null;
  maxTotalUses: number;
  maxPerUser?: number;
  validFrom: string;
  validUntil: string;
  userId?: string | null;
  createdBy?: string;
}

export type UpdateCouponPayload = Partial<CreateCouponPayload>;

export interface SetCouponStatusPayload {
  isActive: boolean;
}

export interface DeleteCouponResult {
  softDeleted: boolean;
}

export interface CouponAdminStats {
  total: number;
  active: number;
  totalRedemptions: number;
  expiring: number;
}
